import {
  Breakpoint,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MuiDialog,
  Paper,
  PaperProps,
  Theme,
} from "@mui/material";
import { ReactNode } from "react";
import Draggable from "react-draggable";
import { useTheme } from "../../../hooks";
import { Form } from "../../common";
import { Box } from "../Box";

function DraggablePaperComponent(props: PaperProps) {
  // use cancel to exclude elements that should not trigger drag: this matters for Touch devices
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'.MuiButtonBase-root, [class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export const Dialog = (props: {
  open: boolean;
  header?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
  width?: string;
  isForm?: boolean;
  onClose?: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void) | undefined;
  maxWidth?: false | Breakpoint | undefined;
  disableDrag?: boolean;
  transitionDuration?:
    | number
    | {
        appear?: number | undefined;
        enter?: number | undefined;
        exit?: number | undefined;
      }
    | {
        appear?: number | undefined;
        enter?: number | undefined;
        exit?: number | undefined;
      }
    | undefined;
  backgroundColor?: (theme: Theme) => string;
}) => {
  const theme = useTheme();
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
    // disabled backdrop click
    if (reason === "backdropClick") {
    } else {
      props.onClose?.(event, reason);
    }
  };

  const handleBackdropClick = (event) => {
    event.stopPropagation();
    return false;
  };

  const dialogBody = (
    <>
      {props.header && (
        <DialogTitle
          style={{ cursor: !props.disableDrag ? "move" : undefined }}
          id="draggable-dialog-title"
          sx={{
            backgroundColor: "#08519c",
            color: "#eff3ff",
            py: 1,
            minHeight: "50px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            fontSize: "1.2rem",
            //borderRadius: 3,
          }}
        >
          <Box width="100%">{props.header}</Box>
        </DialogTitle>
      )}

      {props.content && (
        <DialogContent
          sx={{
            py: "30px !important",
            borderRadius: "15px",
            backgroundColor: !props.backgroundColor ? theme.palette.background.paper : props.backgroundColor,
          }}
        >
          {props.content}

          {/* <BreakpointPlaceholder /> useless: delete */}
        </DialogContent>
      )}

      {props.footer && <DialogActions sx={{ backgroundColor: "rgb(224 237 255)" }}>{props.footer}</DialogActions>}
    </>
  );

  return (
    <MuiDialog
      open={props.open}
      PaperComponent={!props.disableDrag ? DraggablePaperComponent : undefined}
      //aria-labelledby="draggable-dialog-title"
      transitionDuration={{
        appear: 0,
        enter: 0,
        exit: 0,
      }}
      sx={{
        "& .MuiDialog-paper": {
          width: props.width ? props.width : "80%",
          borderRadius: "15px",
          boxShadow: "0px 0px 5px 2px rgb(0 0 0 / 58%)",
        },
      }}
      onClose={handleClose}
      onBackdropClick={handleBackdropClick}
      maxWidth={props.maxWidth}
      // container={() => document.getElementById('root')}
    >
      {props.isForm ? <Form>{dialogBody}</Form> : dialogBody}
    </MuiDialog>
  );
};
